import { render, staticRenderFns } from "./MyFavoritesPatents.vue?vue&type=template&id=6b87bedb&scoped=true"
import script from "./MyFavoritesPatents.vue?vue&type=script&lang=js"
export * from "./MyFavoritesPatents.vue?vue&type=script&lang=js"
import style0 from "./MyFavoritesPatents.vue?vue&type=style&index=0&id=6b87bedb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b87bedb",
  null
  
)

export default component.exports